import { useMapElement } from '../contextProviders/MapElementProvider';
import NameInput from '../common/NameInput';
import translations from '../../../../translations';
import FormGroup from '../../../generic/FormGroup';
import ModalBody from '../../../generic/modal/ModalBody';
import ModalFooter from '../../../generic/modal/ModalFooter';
import { useOpenApi } from '../contextProviders/OpenApiProvider';
import OpenApiActionList from './OpenApiActionList';
import type { MapElementRequestAPI } from '../../../../sources/graph';
import Footer from '../common/Footer';
import OutcomeList from '../common/outcomes/OutcomeList';

/**
 * The openapi config screen
 */
const OpenApiConfiguration = () => {
    const { onClose, mapElement, setMapElement, onSaveMapElement } = useMapElement();
    const { hasSubmitted, setHasSubmitted, isNameValid, onUpdateName, isValidOpenApiElement } =
        useOpenApi();

    if (!mapElement) {
        onClose();
        return;
    }

    const saveOpenApiElement = () => {
        setHasSubmitted(true);
        if (isValidOpenApiElement()) {
            onSaveMapElement(mapElement as MapElementRequestAPI);
        }
    };

    const renderBody = () => (
        <>
            <NameInput
                isValid={isNameValid()}
                showValidation={hasSubmitted}
                id="openapi-name"
                name={mapElement.developerName ?? ''}
                onUpdateName={onUpdateName}
            />
            <OpenApiActionList />
            <OutcomeList />
            <FormGroup
                key="openapi-comments"
                label={translations.OPENAPI_ELEMENT_comments_label}
                htmlFor="openapi-comments"
            >
                <textarea
                    id="openapi-comments"
                    className="form-control form-textarea"
                    value={mapElement.developerSummary ?? ''}
                    onChange={({ target: { value } }) => {
                        setMapElement({
                            ...mapElement,
                            developerSummary: value,
                        });
                    }}
                />
            </FormGroup>
        </>
    );

    const renderFooter = () => {
        return <Footer save={saveOpenApiElement} cancel={onClose} />;
    };

    return (
        <>
            <ModalBody>{renderBody()}</ModalBody>
            <ModalFooter>{renderFooter()}</ModalFooter>
        </>
    );
};

export default OpenApiConfiguration;
